import React, { Component } from 'react'
import ReactDOM from 'react-dom'

class AbstractTooltip {
    constructor(document, useClosingOverall) {
        this.document = document
        this.boxPlacer = new TooltipPlacer()
        this.useClosingOverall = useClosingOverall || false
        this.active = false
    }

    show = (seat) => {
        this.hide()
        this.active = true

        const quadrant = this.boxPlacer.getQuadrant(
            seat.x, seat.y, seat.field_width, seat.field_height)

        this.tooltip = this.document.createElement('div')
        this.tooltip.className = `seatmap-tooltip seatmap-tooltip-${quadrant}`
        this.tooltip.onclick = this.onClick
        this.boxPlacer.configurePosition(
            this.tooltip, seat.x, seat.y, 
            seat.field_width, seat.field_height, quadrant)
        this.document.body.appendChild(this.tooltip)
        if(this.useClosingOverall) setTimeout(
            this.appendClosingOverall, 100)
        this.addContentToTooltip(this.tooltip, seat, this.hide)
    }

    hide = (event) => {
        this.active = false
        if(this.tooltip) {
            this.tooltip.remove()
            delete this.tooltip
        }
        if(this.overall) {
            this.overall.remove()
            delete this.overall
        }
        if(event) {
            event.srcElement.remove()
        }
    }

    appendClosingOverall = () => {
        this.overall = this.document.createElement('div')
        this.overall.className = 'seatmap-overall'
        this.overall.addEventListener("touchstart", this.hide, false)
        this.overall.addEventListener("click", this.hide, false)
        this.document.body.appendChild(this.overall)
    }

    addContentToTooltip()  {
        throw new Error('You should specify `addContentToTooltip` method before')
    }

    isActive = () => {
        return this.active
    }

    onClick = () => {}
}

export class TicketTooltip extends AbstractTooltip {
    addContentToTooltip(domElement, seat) {
        ReactDOM.render((
            <>
                <div className="seatmap-tooltip-name">
                    {seat.key}
                </div>
                <div className="seatmap-tooltip-text">
                    <div>
                        Цена билета: {this.formatSeatPrice(seat.price)}
                    </div>
                    <div>
                        Билет: {this.formatTicketInfo(seat.ticket)}
                    </div>
                    <div className="row">
                        <div className="six columns">
                            <button className='button button-primary' onClick={seat.onSelectRow}>Выбрать весь ряд</button>
                        </div>
                        <div className="six columns">
                            <button className='button button-primary' onClick={seat.onSelectSector}>Выбрать весь сектор</button>
                        </div>
                    </div>
                </div>
            </>
        ), domElement)
    }

    formatTicketInfo = (ticket) => {
        if (ticket) {
            return `${this.getTicketRedableStatus(ticket.status)} - ${ticket.ticket_id}`
        }
        return "Не создан"
    }

    formatSeatPrice = (price) => {
        if (price) {
            return `${price} руб.`
        }
        return "Не назначена"
    }

    getTicketRedableStatus = (status) => {
        if (status === "AVAILABLE") {
            return "Доступен"
        }
        if (status === "BOOKED") {
            return "Забронирован"
        }
        if (status === "SOLD") {
            return "Продан"
        }
        return status
    }
}

export class GASelector extends AbstractTooltip {
    addContentToTooltip(domElement, sector, onClickBack) {
        ReactDOM.render(<GASelectorComponent {...sector} />, domElement)
    }
}

class GASelectorComponent extends Component {
    render () {
        return (
            <>
                <div className="seatmap-tooltip-name">
                    {this.props.name}
                </div>
                <div>
                    Цена билета: {this.props.price} руб.
                    <br />
                    Всего билетов: {this.props.amount} шт.
                    <br />
                    Доступно для покупки: {this.props.amountAvailable} шт.
                    <br />
                    <button className='button button-primary' onClick={this.onEditButtonClick}>Редактировать</button>
                </div>
            </>
        )
    }

    onEditButtonClick = () => {
        this.props.onEdit()
    }
}

class TooltipPlacer {
    constructor() {
        this.x_indent = 10
        this.y_indent = 10
    }

    getQuadrant(x, y, field_w, field_h) {
        const horizontal = x > field_w/2 ? 'right' : 'left'
        const vertical = y < field_h/2 ? 'top' : 'bottom'
        return `${vertical}-${horizontal}`
    }

    configurePosition(element, x, y, field_w, field_h, quadrant) {
        const s = element.style
        s.position = 'absolute'

        if(quadrant.includes('left')) {
            s.left = `${x + this.x_indent}px`
        }
        else if(quadrant.includes('right')){
            s.right = `${field_w - x + this.x_indent}px`
        }

        if(quadrant.includes('top')) {
            s.top = `${y + this.y_indent}px`
        }
        else if(quadrant.includes('bottom')) {
            s.bottom = `${field_h - y + this.y_indent}px`
        }
    }
}
